import React from "react";
import "../../styles/dashboard.css";

const Dashboard = () => {
  return (
    <div className="dashboard-container">
      <h1>Welcome to Your Dashboard</h1>
      <p>Coming soon.........!</p>
      <h1>Welcome to Your Dashboard</h1>
      <p>Coming soon.........!</p>
      <h1>Welcome to Your Dashboard</h1>
      <p>Coming soon.........!</p>
      <h1>Welcome to Your Dashboard</h1>
      <p>Coming soon.........!</p>
      <h1>Welcome to Your Dashboard</h1>
      <p>Coming soon.........!</p>
      <h1>Welcome to Your Dashboard</h1>
      <p>Coming soon.........!</p>
      <h1>Welcome to Your Dashboard</h1>
      <p>Coming soon.........!</p>
      <h1>Welcome to Your Dashboard</h1>
      <p>Coming soon.........!</p>
    </div>
  );
};

export default Dashboard;
